import { useState } from "react";
import { X, Trash2, GripVertical, Plus } from "lucide-react";

export default function ManageStagesModal({ isOpen, stages, onClose, onAdd, onRename, onDelete, onReorder }) {
  const [newStageName, setNewStageName] = useState("");
  const [dragIndex, setDragIndex] = useState(null);

  if (!isOpen) return null;

  const handleAdd = () => {
    const name = newStageName.trim();
    if (!name) return;
    onAdd(name);
    setNewStageName("");
  };

  const handleDrop = (dropIndex) => {
    if (dragIndex === null || dragIndex === dropIndex) return;
    const reordered = [...stages];
    const [moved] = reordered.splice(dragIndex, 1);
    reordered.splice(dropIndex, 0, moved);
    onReorder(reordered);
    setDragIndex(null);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-sm font-semibold text-gray-800">Manage pipeline stages</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={15} />
          </button>
        </div>

        <p className="text-xs text-gray-500 mb-3">Drag to reorder. Default stages can be renamed but not deleted.</p>

        <div className="flex flex-col gap-1.5 mb-4 max-h-72 overflow-y-auto">
          {stages.map((stage, index) => (
            <div key={stage.id} draggable onDragStart={() => setDragIndex(index)} onDragOver={(e) => e.preventDefault()} onDrop={() => handleDrop(index)} className="flex items-center gap-2 border border-gray-100 rounded-lg px-2 py-1.5">
              <GripVertical size={14} className="text-gray-300 cursor-grab flex-shrink-0" />
              <input defaultValue={stage.name} onBlur={(e) => e.target.value.trim() && e.target.value !== stage.name && onRename(stage.id, e.target.value.trim())} className="flex-1 text-sm text-gray-700 border-0 focus:ring-0 outline-none min-w-0" />
              {!stage.is_default && (
                <button onClick={() => onDelete(stage.id)} className="text-gray-300 hover:text-red-500 flex-shrink-0">
                  <Trash2 size={14} />
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="flex gap-2">
          <input value={newStageName} onChange={(e) => setNewStageName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleAdd()} placeholder="New stage name" className="flex-1 border rounded-lg px-3 py-2 text-sm" />
          <button onClick={handleAdd} className="flex items-center gap-1 px-3 py-2 rounded-md text-xs border border-sky-400 bg-sky-400 text-white hover:bg-sky-500">
            <Plus size={14} />
            Add
          </button>
        </div>

        <div className="flex justify-end mt-5">
          <button onClick={onClose} className="px-4 py-2 min-w-32 text-sm rounded-md shadow-sm bg-sky-400 hover:bg-sky-600 duration-200 ease-in-out text-white">
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
